import jsSHA from 'jssha';

import { api } from 'api';
import { user } from 'services';

/**
 * get client type
 * @param {*} type
 * @returns
 */
export const getClientType = (type) => {
  switch (type) {
    case 'natural_person':
      return 'Физическое лицо';
    case 'legal_person':
      return 'Юридическое лицо';
    case 'sole_proprietor':
      return 'Индивидуальный предприниматель';
    default:
      return '';
  }
};

/**
 * topup
 * @param {*} data
 * @returns
 */
export const topup = (data) => {
  return api.call('clients.replenish', data);
};

/**
 * change amount
 * @param {*} data
 * @returns
 */
export const adjustBalance = (data) => {
  return api.call('clients.adjust_balance', data);
};

/**
 * prepare client after load
 * @param {*} data
 * @returns
 */
const prepareClientAfterLoad = (data) => {
  const out = {};
  for (let item in data) {
    if (data[item] === null) {
      out[item] = '';
    } else {
      out[item] = data[item];
    }
    out[item] = data[item];
  }
  return out;
};

/**
 * get client
 * @param {*} id
 * @returns
 */
export const getClient = (id) => {
  return api
    .call('clients.view', {
      id: id,
    })
    .then((data) => {
      return prepareClientAfterLoad(data);
    });
};

/**
 * get client balance
 * @param {*} id
 * @param {*} callback
 * @returns
 */
export const getClientBalance = (id) => {
  return api.call('processing.get_balance', { client_id: id });
};

/**
 * change client status
 * @param {*} id
 * @param {*} status
 * @returns
 */
export const changeClientStatus = (id, status) => {
  const data = {
    id,
    status,
  };

  return api.call('clients.change_status', data);
};

/**
 * add client
 * @param {*} data
 * @returns
 */
export const addClient = (data) => {
  return api.call('clients.add', data);
};

/**
 * update client
 * @param {*} params
 * @returns
 */
export const updateClient = (params) => {
  const useLogin = user.canUserLogin();
  const password = params.lkpwd;
  const withLogin = params?.lk_login;
  if (useLogin) {
    delete params.lkpwd;
  }
  // clear unneeded
  if (params.account) {
    delete params.account;
  }
  if (params.data) {
    // if (params.data.account) {
    //   delete params.data.account;
    // }
    // if (params.data.data) {
    //   delete params.data.data;
    // }
    delete params.data;
  }

  return new Promise((resolve, reject) => {
    // update client
    api
      .call('clients.update', params)
      .then((data) => {
        if (!useLogin || (!withLogin && !password)) {
          resolve(prepareClientAfterLoad(data));
          return;
        }

        // use login variants
        // 1. set password (no password and unlimited)
        // 2. update unlimited (no password)
        // 3. update unlimited and password
        // all above if withLogin, else only password
        const out = { client_id: params.id, unlimited: params.lk_unlimited ?? false };

        // if password - encode it
        if (password) {
          const shaObj = new jsSHA('SHA-256', 'TEXT', { encoding: 'UTF8' });
          shaObj.update(password);
          const encoded = shaObj.getHash('HEX');
          out.password = encoded;
        }
        api
          .call('clients.lk_add', out)
          .then((lk) => {
            let clientInfo = prepareClientAfterLoad(data);
            clientInfo.data.lk_login = lk;
            resolve(clientInfo);
          })
          .catch((error) => {
            reject(typeof error === 'string' ? error : error.message.toString());
          });
      })
      .catch((error) => {
        reject(error.toString());
      });
  });
};

/**
 * update client contact
 * @param {*} data
 * @param {*} clientId
 * @returns
 */
export const updateContact = (data, _clientId) => {
  return api.call('clients.update_contact', {
    id: data.id,
    item: data,
  });
};

/**
 * add client contact
 * @param {*} data
 * @param {*} clientId
 * @returns
 */
export const addContact = (data, clientId) => {
  return api.call('clients.add_contact', {
    client_id: clientId,
    item: data,
  });
};
